import React, { Component, useEffect } from 'react';
import { Container } from 'react-bootstrap';

const AccountDelete = () => {

    return (
        <Container className='content' >
            <h1>Account Delete</h1>
            <p> Guide users through the process of deleting their account. </p>
        </Container>
    );

}

export default AccountDelete;